import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { getPaymentStatus } from '../services/api';

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (!sessionId) {
      navigate('/');
      return;
    }

    pollPaymentStatus();
  }, [sessionId, attempts]);

  const pollPaymentStatus = async () => {
    if (attempts >= 5) {
      setStatus('timeout');
      return;
    }

    try {
      const response = await getPaymentStatus(sessionId);
      if (response.data.payment_status === 'paid') {
        setStatus('success');
      } else if (response.data.status === 'expired') {
        setStatus('expired');
      } else {
        // Continue polling
        setTimeout(() => setAttempts(attempts + 1), 2000);
      }
    } catch (error) {
      console.error('Error checking payment status:', error);
      setTimeout(() => setAttempts(attempts + 1), 2000);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        {status === 'checking' && (
          <>
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-[#0F2A44] mx-auto mb-6"></div>
            <h1 className="font-manrope font-bold text-2xl text-[#0F2A44] mb-2">
              Processing Payment
            </h1>
            <p className="font-public text-[#4B5563]">
              Please wait while we confirm your payment...
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="h-16 w-16 text-[#2DD4BF] mx-auto mb-6" />
            <h1 className="font-manrope font-bold text-3xl text-[#0F2A44] mb-2">
              Payment Successful!
            </h1>
            <p className="font-public text-[#4B5563] mb-8">
              Thank you for your purchase. Your featured/sponsored listing is now active.
            </p>
            <Button
              onClick={() => navigate('/doctor/dashboard')}
              className="bg-[#0F2A44] hover:bg-[#0F2A44]/90 text-white rounded-lg px-8"
            >
              Go to Dashboard
            </Button>
          </>
        )}

        {(status === 'expired' || status === 'timeout') && (
          <>
            <h1 className="font-manrope font-bold text-2xl text-[#0F2A44] mb-2">
              Payment Verification Issue
            </h1>
            <p className="font-public text-[#4B5563] mb-8">
              We couldn't verify your payment. Please check your email for confirmation or contact support.
            </p>
            <Button
              onClick={() => navigate('/')}
              className="bg-[#0F2A44] hover:bg-[#0F2A44]/90 text-white rounded-lg px-8"
            >
              Return Home
            </Button>
          </>
        )}
      </div>
    </div>
  );
}